<template>
    <div class="v-date-filter-holder">
        <v-datepicker-public ref="picker" :label="label" :name="name" :value="date" @input="inputHandler"></v-datepicker-public>
        <div class="v-date-filter__date-controls" v-if="this.date">
            <span @click="prev"><i class="fa fa-angle-left"></i></span>
            <span @click="next"><i class="fa fa-angle-right"></i></span>
        </div>
    </div>

</template>

<script>
    import field from '../mixins/field';
    import VDatepickerPublic from './VDatepickerPublic';
    import 'moment';

    export default {
      mixins: [field],
      components: {
        VDatepickerPublic
      },
      data() {
        return {
          date: this.value,
        }
      },
      methods: {
        next() {
          if (this.date) {
            let datetime = this.date.split(' ');
            let date = datetime[0].split('-');
            let prevDate = new Date(date[2], parseInt(date[1]) - 1, date[0]).getTime();
            this.date = moment(prevDate).add(1, 'd').format('DD-MM-YYYY');
            this.$emit('next', this.date);
          }
        },
        prev() {
          if (this.date) {
            let datetime = this.date.split(' ');
            let date = datetime[0].split('-');
            let prevDate = new Date(date[2], parseInt(date[1]) - 1, date[0]).getTime();
            this.date = moment(prevDate).subtract(1, 'd').format('DD-MM-YYYY');
            this.$emit('prev', this.date);
          }
        },
        inputHandler(value) {
          this.date = value;
          this.$emit('phrase', value);
        }
      },
      watch: {
        value(newValue) {
          this.date = newValue;
        }
      }
    }
</script>